import { artists } from '@/mocks/gallery';

export default function Artists() {
  return (
    <section id="artists" className="relative w-full scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2">
          <span className="text-sm font-medium uppercase tracking-widest text-accent-500">Featured Artists</span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">画师精选</h2>
          <p className="max-w-2xl text-sm text-foreground-300 md:text-base">
            认识这些用画笔描绘娜美同人世界的优秀画师，作品均署名收录、版权归原作者所有。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {artists.map((artist) => (
            <article
              key={artist.id}
              className="rounded-lg bg-background-100 p-5 ring-1 ring-background-200/60 transition-colors hover:ring-secondary-500/40"
            >
              <div className="flex items-center gap-4">
                <img
                  src={artist.avatar}
                  alt={`画师${artist.name}的头像`}
                  title={`画师${artist.name}`}
                  className="h-14 w-14 rounded-full object-cover object-top ring-2 ring-primary-500/40"
                />
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-50">{artist.name}</h3>
                  <p className="mt-0.5 text-xs text-primary-300">{artist.tagline}</p>
                </div>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-300">{artist.intro}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/60 pt-4">
                <span className="text-xs text-foreground-400">收录作品 {artist.works} 幅</span>
                <button
                  type="button"
                  className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300/60 px-3 py-1.5 text-xs font-medium text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-300"
                >
                  查看主页 <i className="ri-arrow-right-line text-sm"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}